import React, { useState, useRef } from "react";
import {
    FormControl,
    Chip,
    Select,
    MenuItem,
    Checkbox,
    ListItemText,
    IconButton,
    Input,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import "./MainView.css";

const FilterSelect = ({ label, options, selectedValues, onChange, onRemove, disabled }) => {
    const [searchValue, setSearchValue] = useState("");
    const searchInputRef = useRef(null);

    // Filter options based on search
    const filteredOptions = options.filter(option =>
        searchValue ? option.toLowerCase().includes(searchValue.toLowerCase()) : true
    );

    return (
        <FormControl className="source-list" size="small">
            <Chip
                className={`chips mr-2 ${disabled ? "disabled" : ""}`}
                label={`${label} ${
                    selectedValues.length > 0
                        ? " | " +
                          (selectedValues.length === options.length
                              ? "All"
                              : selectedValues.length > 2
                              ? selectedValues.slice(0, 2).join(", ") +
                                `, +${selectedValues.length - 2} more`
                              : selectedValues.join(", "))
                        : ""
                }`}
                onDelete={selectedValues.length > 0 ? onRemove : undefined}
            />
            <Select
                multiple
                value={selectedValues}
                onChange={onChange}
                className={disabled ? "disabled" : ""}
                sx={{ width: "calc(100% - 40px)", borderRadius: "10px" }}
                MenuProps={{
                    autoFocus: false,
                }}
            >
                {label === "Business Service" && (
                    <div className="d-flex flex-column mt-1 bg-white position-sticky bottom-0 pb-2 px-3">
                        <div className="d-flex align-items-center position-relative">
                            <Input
                                inputRef={searchInputRef}
                                value={searchValue}
                                onChange={(e) => setSearchValue(e.target.value)}
                                onKeyDown={(e) => e.stopPropagation()}
                                sx={{ fontSize: "0.9rem", lineHeight: "1.5", width: "100%", paddingRight: '30px' }}
                                placeholder="Search"
                            />
                            {searchValue && (
                                <IconButton
                                    onClick={() => setSearchValue("")}
                                    sx={{
                                        position: "absolute",
                                        right: "10px",
                                        cursor: "pointer",
                                        padding: 0,
                                        pb: "6px",
                                    }}
                                    aria-label="clear"
                                    size="small"
                                >
                                    <ClearIcon />
                                </IconButton>
                            )}
                        </div>
                    </div>
                )}

                {label === "Business Service" && (
                    <MenuItem value="all">
                        <Checkbox
                            checked={selectedValues.length === options.length}
                            indeterminate={selectedValues.length > 0 && selectedValues.length < options.length}
                        />
                        <span className="text-truncate text-sm mt-1">Select all</span>
                    </MenuItem>
                )}

                {filteredOptions.map((option) => (
                    <MenuItem key={option} value={option}>
                        <Checkbox checked={selectedValues.includes(option)} />
                        <ListItemText primary={option} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default FilterSelect;
